export default __webpack_public_path__ + "static/media/smileySearch.73cdd2ef.svg";